module.exports = __webpack_public_path__ + "static/img/1069_big.8c94806.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1069_big.png
// module id = B5wU
// module chunks = 1